import { render, staticRenderFns } from "./page_setting.vue?vue&type=template&id=28f9814c&scoped=true&"
import script from "./page_setting.vue?vue&type=script&lang=js&"
export * from "./page_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9814c",
  null
  
)

export default component.exports